/** A short arrival per object, rather than a simultaneous sweep of the map. */
export const CONSTRUCTION_DURATION = 260;
export const CONSTRUCTION_LIFT = 64;
export function constructionTiming(count: number) {
  // Keep individual arrivals visible, while bounding large imports to ~2.5 s.
  const step = Math.min(18, 2200 / Math.max(1, count - 1));
  return {
    delay: (index: number) => index * step,
    end: Math.max(0, count - 1) * step + CONSTRUCTION_DURATION
  };
}
